import { useState } from 'react'
import { supabase } from './supabase'

export default function Login({ onSuccess, onSignup }) {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const handleLogin = async () => {
    setError(null)
    if (!email || !password) return setError('Please enter your email and password.')
    setLoading(true)
    const { error: loginError } = await supabase.auth.signInWithPassword({ email, password })
    setLoading(false)
    if (loginError) return setError('Incorrect email or password.')
    onSuccess()
  }

  return (
    <div style={s.screen}>
      <div style={s.header}>
        <img src='/crossbet-logo.png' alt='Crossbet' style={s.logoImg} />
        <div style={s.wordmark}>CROSSBET</div>
        <div style={s.tagline}>Welcome back</div>
      </div>
      <div style={s.body}>
        <div style={s.field}>
          <label style={s.label}>EMAIL</label>
          <input style={s.input} type="email" placeholder="your@email.com" value={email} onChange={e => setEmail(e.target.value)} onKeyDown={e => e.key === 'Enter' && handleLogin()} />
        </div>
        <div style={s.field}>
          <label style={s.label}>PASSWORD</label>
          <input style={s.input} type="password" placeholder="••••••••" value={password} onChange={e => setPassword(e.target.value)} onKeyDown={e => e.key === 'Enter' && handleLogin()} />
        </div>
        {error && <div style={s.error}>{error}</div>}
        <button style={{ ...s.btn, opacity: loading ? 0.7 : 1 }} onClick={handleLogin} disabled={loading}>
          {loading ? 'Signing in...' : 'Sign In'}
        </button>
        <div style={s.signupLink}>
          New to CROSSBET?{' '}
          <span style={s.link} onClick={onSignup}>Create account</span>
        </div>
      </div>
    </div>
  )
}

const s = {
  screen: { minHeight: '100vh', background: '#FDF9E7', display: 'flex', flexDirection: 'column', fontFamily: "'Outfit', 'DM Sans', sans-serif", overflowX: 'hidden', width: '100%' },
  header: { background: '#00563F', padding: '48px 24px 32px', display: 'flex', flexDirection: 'column', alignItems: 'center' },
  logoImg: { width: 80, height: 80, objectFit: 'contain' },
  wordmark: { fontFamily: "'Outfit', sans-serif", fontSize: 36, fontWeight: 800, color: '#FDF9E7', letterSpacing: 6, lineHeight: 1, marginTop: 8 },
  tagline: { fontSize: 12, color: 'rgba(253,249,231,0.5)', marginTop: 8, letterSpacing: 2, textTransform: 'uppercase' },
  body: { flex: 1, padding: '32px 16px 48px', display: 'flex', flexDirection: 'column', gap: 16, maxWidth: 480, width: '100%', margin: '0 auto', boxSizing: 'border-box' },
  field: { display: 'flex', flexDirection: 'column', gap: 6 },
  label: { fontSize: 11, fontWeight: 700, color: '#7A7570', letterSpacing: 1.5, textTransform: 'uppercase' },
  input: { background: '#FFFFFF', border: '1.5px solid #D0CCC0', borderRadius: 12, padding: '13px 16px', fontSize: 15, color: '#1A1814', fontFamily: 'inherit', outline: 'none', width: '100%', boxSizing: 'border-box' },
  error: { background: 'rgba(192,57,43,0.08)', border: '1px solid rgba(192,57,43,0.25)', borderRadius: 12, padding: '12px 16px', fontSize: 14, color: '#C0392B' },
  btn: { background: '#00563F', color: '#FDF9E7', border: 'none', borderRadius: 14, padding: '16px 24px', fontSize: 15, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit', letterSpacing: 0.5 },
  signupLink: { textAlign: 'center', fontSize: 14, color: '#7A7570' },
  link: { color: '#00563F', fontWeight: 600, cursor: 'pointer' },
}
